<template>
    <div>
        <div class="alert alert-success shadow">
            <h3>{{ caption }}</h3>
            <p>Оцените главу и нажмите "Завершить".</p>
            <!-- <h1>{{mark}}</h1> -->
            <div class="p-0 ">
                <label>
                    <input v-model="mark" name="mark" type="radio" value="1">
                    <img src="/icons/star_gold.png">
                </label>
                <label>
                    <input v-model="mark" name="mark" type="radio" value="2">
                    <img v-if="mark > 1" src="/icons/star_gold.png">
                    <img v-else src="/icons/star_black.png">
                </label>
                <label>
                    <input v-model="mark" name="mark" type="radio" value="3">
                    <img v-if="mark > 2" src="/icons/star_gold.png">
                    <img v-else src="/icons/star_black.png">
                </label>
                <label>
                    <input v-model="mark" name="mark" type="radio" value="4">
                    <img v-if="mark > 3" src="/icons/star_gold.png">
                    <img v-else src="/icons/star_black.png">
                </label>
                <label>
                    <input v-model="mark" name="mark" type="radio" value="5">
                    <img v-if="mark > 4" src="/icons/star_gold.png">
                    <img v-else src="/icons/star_black.png">
                </label>
            </div>
            <p class="your_mark">Ваша оценка - {{mark}}</p>
            <button type="button" class="btn btn-primary" @click.prevent="finishChapter">Завершить Главу</button>            
        </div>

        <div class="alert alert-danger" v-if="errors.any">
            {{ errors.any }}
        </div>

    </div>
</template>
<script>
import axios from 'axios'
export default {
    props: {
        chapter: Object,
        caption: String,
    },
    data() {
        return {
            mark: 5,
            errors: {any: '' },
        }
    },
    mounted() {
        
    },
    methods: {
        async finishChapter() {
            this.errors.any = ''
            try {
                let response = await axios.post('chapters/'+this.$route.params.id+'/finish', {mark: this.mark})
                if (response.status == 200) {
                    // Нельзя делать редирект на текущую страницу.
                    // Поэтому если надо обновить текущую страницу, мы об этом передаём с помощью $emit:
                    if (this.$route.name != 'chapter_show') {
                        this.$router.push({ name: 'chapter_show', params: {id: this.$route.params.id} });
                    }
                    else {
                        this.$emit('need-to-reload')
                    }
                }
            }
            catch(e) {         
                if (e.response.status == 520) {
                    this.errors.any = e.response.data.error
                }
                else {
                    this.errors.any = "Неизвестная ошибка при завершении Главы."
                }
            }
        },
    }
}
</script>

<style scoped>
.your_mark {
    font-size: 80%;
    color: grey;
}
label {
    margin: 0;
}
label > input{ /* HIDE RADIO */
  visibility: hidden; /* Makes input not-clickable */
  position: absolute; /* Remove input from document flow */
}
label > input + img{ /* IMAGE STYLES */
  cursor:pointer;
  border:2px solid transparent;
}
</style>